import { render } from "./ProfileInfosDetails.vue?vue&type=template&id=2e5099c4"
import script from "./ProfileInfosDetails.vue?vue&type=script&lang=js"
export * from "./ProfileInfosDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__